/**
 * Produktabbildungen.
 *
 * WO DIE BILDER LIEGEN
 *
 * `apps/web/public/assets/products/families/` -- 22 Katalogabbildungen, von
 * Arne im Zuge der Migration abgelegt. Es sind FAMILIENBILDER: eine Aufnahme
 * je Produktreihe, nicht je SKU. Das ist auch fachlich richtig --
 * TP154-4KD2D, TP154-4KD2D-60 und TP154-4KD2D-EMGCY zeigen dasselbe
 * physische Produkt und teilen sich eine Abbildung.
 *
 * WIE ZUGEORDNET WIRD
 *
 * Ueber den FAMILIENCODE, in Kleinschreibung, Sonderzeichen zu Bindestrichen:
 *
 *     "TP PRO"   -> tp-pro.jpg
 *     "RetroFix" -> retrofix.jpg
 *     "HB UGR"   -> hb-ugr.jpg
 *
 * Es entsteht dadurch KEINE neue Datenstruktur: der Artikel traegt seine
 * Familienzuordnung bereits, und der Dateiname folgt aus deren Code.
 *
 * GRENZE DIESER LOESUNG -- BEFUND FUER 02
 *
 * Die Regel deckt 12 der 36 Produktfamilien ab. Die uebrigen 10 Dateien
 * folgen einer ANDEREN Benennung: `d90`, `d125`, `d165`, `d200` und `pr30`
 * sind nach Baureihen benannt, `tl-variozoom` ist die Kurzform von
 * „TRACKLIGHT VARIOZOOM", `area-pro-sports` steht neben der Familie „AREA
 * SPORT", und `sosen-ca` / `sosen-vp` folgen einem Herstellernamen. Diese
 * Zuordnungen lassen sich NICHT aus dem Familiencode ableiten; sie zu raten
 * hiesse, einem Produkt ein fremdes Bild zu geben.
 *
 * Eine belastbare Loesung braucht eine ausdrueckliche Zuordnung -- am
 * ehesten eine Spalte `product_families.image_path`, so wie sie fuer
 * Produktmodelle mit `product_models.image_path` bereits existiert. Das ist
 * eine Migration und damit eine Entscheidung von 02, nicht dieses Blocks.
 *
 * Bis dahin gilt: eine Datei, die es nicht gibt, fuehrt zur neutralen
 * Leerflaeche -- nie zu einem kaputten Bildsymbol.
 */

const VERZEICHNIS = "/assets/products/families";

/**
 * Der Dateiname zu einem Familiencode.
 *
 * Bewusst ohne Ausnahmeliste: eine Tabelle mit zehn handverdrahteten
 * Sonderfaellen im Frontend waere genau die Zuordnung, die in die Datenbank
 * gehoert. Was die Regel nicht trifft, bleibt ohne Bild und faellt damit auf.
 */
export function familyImageSlug(code: string): string {
  return code.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

/**
 * Der Bildpfad eines Artikels -- ueber seine Produktfamilie.
 *
 * Mehrfachzuordnungen sind moeglich; gewaehlt wird die primaere Familie, sonst
 * die erste. Ohne Familie gibt es kein Bild.
 */
export function articleImageSrc(
  families: readonly { readonly code: string; readonly isPrimary: boolean }[],
): string | null {
  const familie = families.find((f) => f.isPrimary) ?? families[0];
  if (familie === undefined) return null;
  return `${VERZEICHNIS}/${familyImageSlug(familie.code)}.jpg`;
}
